import moment from 'moment';
import Editor from "datatables.net-editor";
import "datatables.net-editor-bs5";
import {getDataTableEditorFormButtons, getDataTableEditorOptions} from "@/helpers/datatable/datatable-editor-helper";
import {callService, reloadServiceClick} from "@/helpers/ol/ol-http-helper";
import {
    addLayer, getBookmarkPresentationsByID,
    getLayerByName,
    refreshAllActiveLayers,
    refreshLayer,
    removeLayer
} from "@/helpers/ol/ol-layer-helper";
import {getMutationLayerName} from "@/helpers/tools/tools-mutation-helper";
import {GeoJSON, WKT} from "ol/format";
import toastr from "toastr";
import {clearInfo} from "@/helpers/layer/info/layer-info-info-helper";
import {clearGeoJsonLayers, generateGeoJsonObjectFromFeature} from "@/helpers/ol/ol-geo-json-helper";
import {disableMoveLayer} from "@/helpers/ol/map/ol-move-helper";
import $ from "jquery";
import {clearToolsMutationSelectLayerItem} from "@/helpers/tools/tools-mutation-select-layer-helper";
import {initDataTableEditorEvents} from "@/helpers/datatable/datatable-editor-event-helper";
import {Feature} from "ol";
import {getArea, getLength} from "ol/sphere";
import {OL3Parser, WKTReader} from "jsts/org/locationtech/jts/io";
import {GeometryFactory} from "jsts/org/locationtech/jts/geom";
import {LineString, MultiLineString, MultiPoint, MultiPolygon, Point, Polygon} from "ol/geom";
import { IsValidOp } from 'jsts/org/locationtech/jts/operation/valid';

export function getDataTableByFormIDAndFeatureID(formID, featureID) {
    return window.dataTables.find(dataTable =>
        parseInt(dataTable.FormID) === parseInt(formID) &&
        ( String(dataTable.FeatureID) === featureID || String(dataTable.feature.id) === featureID)
    )
}

export function getDataTableByPresentationIDAndDomainIDAndFormID(domainID, presentationID, formID) {

    return window.dataTables.find(item =>
        item.PresentationID === parseInt(presentationID) &&
        item.DomainID === parseInt(domainID) &&
        item.FormID === parseInt(formID)
    )
}

export function initDataTableStandAloneEditor(dataTable, type = 'edit', isLinked = false) {

    // console.log(dataTable)

    const bookmarkPresentationID = dataTable.BookmarkPresentationID
    Editor.bootstrap( bootstrap );
    window.moment = moment

    let geometry
    let featureID
    let record
    if(dataTable.featureInfo.records && dataTable.featureInfo.records.length > 0) {
        record = dataTable.featureInfo.records[0]

        featureID = record.featureid
        if(String(featureID).includes('.')) {
            featureID = featureID.split('.')[1]
        }

        const features = generateGeoJsonObjectFromFeature(record, false)
        geometry = features[0].getGeometry()
    }

    const editorOptions= getDataTableEditorOptions(dataTable, name, true, featureID)
    let editor = new Editor(editorOptions);

    switch (type) {
        case 'remove':
            editor
                .title('Object verwijderen')
                .remove(parseInt(featureID))
                .buttons(getDataTableEditorFormButtons(type, true)
                )

            editor.message('<div class="alert alert-danger alert-dismissible fade show mb-0">' +
                'Weet u zeker dat u dit object wilt met ID {' + featureID + '} verwijderen?' +
                '</div>');
            break;
        case 'edit':
            editor
                .title( 'Object bewerken' )
                .edit(parseInt(featureID), {
                    focus: null
                })
                .buttons(getDataTableEditorFormButtons(type, true))
            break;
        case 'create':
            editor
                .title( 'Object toevoegen' )
                .create(this, {
                    focus: null
                })
                .buttons(getDataTableEditorFormButtons(type, true, isLinked)
                )
    }

    let rowData = {}
    if(record) {
        record.attributes.map( (attribute) => {
            attribute.map( attributeItem => {
                rowData[attributeItem.Attribute] = attributeItem.Value
                const field = editor.field( attributeItem.Attribute)
                if(field && attributeItem.MutationTypeID !== 16) {
                    field.set(attributeItem.Value )
                }
            })
        })
    }

    let editorMessage = ''
    if(window.mutation_geom) {
        const wkt = new WKT();
        geometry = wkt.writeGeometry(window.mutation_geom)

        // Check valid geometry
        const reader = new WKTReader(new GeometryFactory());
        const geom = reader.read(geometry);

        if(!new IsValidOp(geom).isValid()) {
            editorMessage += '<div class="alert alert-warning alert-dismissible fade show mb-2">' +
                'Dit vlak heft overlappende geometrie. Klik op herstellen om het aan te passen of klik op opslaan om het vlak op te slaan.' +
                '</div>';
        }

        editor.set(window.mutation_geom_column, geometry)
        if(type === 'edit') {

            // console.log(dataTable.attributes)

            const attributes = dataTable.attributes
                .filter(
                    attribute => attribute.Type !== 21 && ![8,9].includes(attribute.MutationTypeID)
                )
                .map(attribute => { return attribute.Attribute })

            //  ||

            editor.clear( attributes );
            if(editorMessage === '') {
                editorMessage += '<div class="alert alert-warning alert-dismissible fade show mb-0">' +
                    'Hiermee wordt de geometrie van het object aangepast. Wilt u de wijzigingen opslaan?' +
                    '</div>';
            }
        }
    }

    editor = initDataTableEditorEvents(dataTable, editor, editorOptions, rowData, undefined, window.mutation_geom, editorMessage)

    editor.open();

    editor.on('submitSuccess', (e, json, data, action) => {

        clearToolsMutationSelectLayerItem()

        if(json.error) {
            toastr.error('Er is iets fout gegaan. Neem contact op met de beheerder')
            return
        }

        switch (action) {
            case 'create':
                removeLayer(getMutationLayerName(), false)
                refreshAllActiveLayers()

                toastr.success('Het object is toegevoegd')

                if(isLinked) {
                    reloadServiceClick()
                } else {
                    if(!window.closeType || window.closeType !== 'cancel') {

                        console.log('calll', data)

                        let featureID = data.featureid
                        const bookmarkPresentation = getBookmarkPresentationsByID(bookmarkPresentationID)
                        if(bookmarkPresentation.PrimaryKeyName) {
                            if(data[bookmarkPresentation.PrimaryKeyName]) {
                                featureID = data[bookmarkPresentation.PrimaryKeyName]
                            } else {
                                featureID = featureID.split('.')[1]
                            }
                        }

                        callService(bookmarkPresentationID, featureID, 'wfs')
                    }
                }
                break;
            case 'edit':
                if(window.mutation_geom) {
                    refreshAllActiveLayers()
                } else {
                    reloadServiceClick()
                    refreshAllActiveLayers()
                }
                toastr.success('Het object is gewijzigd')
                break;
            case 'remove':
                refreshAllActiveLayers()

                if(isLinked) {
                    reloadServiceClick()
                } else {
                    clearInfo()
                }

                toastr.success('Het object is verwijderd')
                break;
        }

        delete window.mutation_geom

        disableMoveLayer()
    })
}
